module.exports = __webpack_public_path__ + "img/arrows-to-dotted-line.02d23a5c.svg";